/* eslint-disable react-native/no-inline-styles */
import React from 'react';
import { ScreenName } from '../../common/enum';
import { Branding } from '../../component/Branding/Branding';
import useBehaviorSubjectState from '../../hooks/rxjs/useSubjectState';
import { useCartSetActiveScreen } from '../../hooks/useCartNavigationHelper/useCartSwitcherEffect';
import { sessionSubject } from '../../state/sessionObservable';
import { StyleSheet, View } from 'react-native';
import SystemStatus from '../../component/SystemStatus/SystemStatus';

const styles = StyleSheet.create({
  buttonContainer: {
    position: 'absolute',
    top: 20,
    right: 20,
    zIndex: 2,
  },
});

const IdleScreen: React.FC = () => {
  useCartSetActiveScreen(ScreenName.IDLE);
  const { value: session } = useBehaviorSubjectState(sessionSubject);

  return (
    <View style={{ flex: 1 }}>
      <Branding
        screenConfig={
          session?.device?.deviceProfile?.customerDisplay?.idleScreen
        }
        brandColor={session?.device?.deviceProfile?.customerDisplay?.brandColor}
        storeName={session?.currentStore?.name}
      />
      <View style={styles.buttonContainer}>
        <SystemStatus />
      </View>
    </View>
  );
};

export default IdleScreen;
